<template>
  <v-card-text>
    <v-toolbar
      density="compact"
      v-if="!showResultCard"
      class="custom-card px-4 py-1 d-flex flex-wrap align-center justify-space-between mb-2"
      color="white"
    >
      <v-chip-group
        v-model="filterStatus"
        selected-class="bg-primary text-white border-primary"
        mandatory
      >
        <v-chip
          v-for="status in statusFilters"
          :key="status.value"
          :value="status.value"
          variant="outlined"
          color="white"
          class="font-weight-bold px-4"
        >
          {{ status.label }}
        </v-chip>
      </v-chip-group>

      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        prepend-icon="mdi-plus"
        class="btn-primary-gradient"
        @click="openCreateDialog"
      >
        Create New Poll
      </v-btn>
    </v-toolbar>

    <div v-if="!showResultCard">
      <v-card class="custom-card">
        <v-data-table
          :headers="headers"
          :items="GetAllPollsList"
          :height="vuetifyObject?.height - 194"
          v-model:page="page"
          class="elevation-0"
          density="compact"
          hide-default-footer
          :loading="loading"
          :items-per-page="itemsPerPage"
          @click:row="viewResults"
        >
          <template v-slot:[`item.title`]="{ item }">
            <div class="font-weight-600">{{ item.title }}</div>
          </template>

          <template v-slot:[`item.vote_counts`]="{ item }">
            <v-chip size="small" variant="tonal" color="primary">
              <v-icon start icon="mdi-vote"></v-icon>
              {{
                Object.values(item.vote_counts).reduce(
                  (sum, val) => sum + val,
                  0,
                )
              }}
              Votes
            </v-chip>
          </template>
          <template v-slot:[`item.creator_email_id`]="{ item }">
            <div v-if="item.creator_email_id" class="font-weight-medium">
              {{
                item.target_value == "PRIVATE"
                  ? "Private"
                  : item.creator_email_id
              }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:[`item.target_value`]="{ item }">
            <v-chip
              color="light-blue"
              size="small"
              class="font-weight-bold text-capitalize"
            >
              {{ item.target_value.toLowerCase() }}
            </v-chip>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            <div style="min-width: 110px" class="py-1">
              <div class="d-flex justify-space-between align-center mb-1">
                <span
                  :class="getTimeColorText(item)"
                  class="text-caption font-weight-bold"
                  style="font-size: 0.7rem !important"
                >
                  <v-icon
                    size="x-small"
                    class="mr-1 pb-1"
                    v-if="getTimelineProgress(item) < 100"
                    >mdi-clock-outline</v-icon
                  >
                  {{ getTimeLeftText(item) }}
                </span>
                <span
                  class="text-caption text-grey-darken-1"
                  style="font-size: 0.65rem !important"
                >
                  {{ getTimelineProgress(item) }}%
                </span>
              </div>
              <v-progress-linear
                :model-value="getTimelineProgress(item)"
                :color="getTimeColor(item)"
                height="5"
                rounded
              ></v-progress-linear>
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex gap-2">
              <v-menu
                v-if="
                  item.poll_status == 'LIVE' ||
                  item.poll_status == 'UPCOMING' ||
                  item.poll_status == 'COMPLETED'
                "
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    size="small"
                    variant="text"
                    icon="mdi-dots-vertical"
                    v-bind="props"
                  ></v-btn>
                </template>
                <v-list density="compact" class="text-subtitle">
                  <v-list-item
                    v-if="
                      item.poll_status === 'UPCOMING' ||
                      item.poll_status === 'LIVE'
                    "
                    title="Edit Poll"
                    @click="editPoll(item)"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        size="small"
                        color="green"
                        icon="mdi-pencil"
                      ></v-icon>
                    </template>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      item.poll_status == 'LIVE' ||
                      item.poll_status == 'UPCOMING'
                    "
                    density="compact"
                    icon-color="red"
                    :title="`${
                      item.poll_status === 'LIVE' ? 'Abort' : 'delete'
                    } Poll`"
                    @click="deletePoll(item)"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        size="small"
                        color="red"
                        :icon="
                          item.poll_status === 'LIVE'
                            ? 'mdi-archive'
                            : 'mdi-delete'
                        "
                      ></v-icon>
                    </template>
                  </v-list-item>
                  <v-list-item
                    v-if="item.poll_status === 'COMPLETED'"
                    title="Re-Poll"
                    @click="rePollMethod(item)"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        size="small"
                        color="info"
                        icon="mdi-refresh"
                      ></v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon class="ps-5" v-else color="primary">mdi-eye</v-icon>
            </div>
          </template>
        </v-data-table>
        <v-pagination
          density="compact"
          :length="pageCount"
          v-model="page"
        ></v-pagination>
      </v-card>

      <poll-dialog
        v-model:dialog="pollDialog"
        :selected-poll="selectedPoll"
        :internalPincodes="internalPincodes"
        @clicked="pollDialogEmitt"
      />
    </div>
    <div v-if="showResultCard">
      <result-card
        :vuetifyObject="vuetifyObject"
        :internalPincodes="internalPincodes"
        :poll-data="selectedPoll"
        :pollList="GetAllPollsList"
        @back="showResultCard = false"
        @repoll="rePollMethod"
        @nextPoll="nextPollMethod"
        @previousPoll="previousPollMethod"
      />
    </div>
    <ActivateDeactivatePollDialog
      :activateDeactivatePollDialog="activateDeactivatePollDialog"
      :poll="selectedPoll"
      :isDelete="isDelete"
      @update="activateDeactivatePollDialogEmit"
    />
  </v-card-text>
</template>

<script>
import PollCard from "@/components/Polls/Cards/PollCard.vue";
import PollDialog from "@/components/Polls/Dialogs/PollDialog.vue";
import { GetAllPolls } from "@/mixins/Polls/GetAllPolls";
import ActivateDeactivatePollDialog from "@/components/Polls/Dialogs/ActivateDeactivatePollDialog.vue";
import ResultCard from "@/components/Polls/Cards/ResultCard.vue";
import { GetScratchPadText } from "@/mixins/Extras/GetScratchPadText";

export default {
  name: "PollsPage",
  components: {
    ResultCard,
    PollCard,
    PollDialog,
    ActivateDeactivatePollDialog,
  },
  props: {
    vuetifyObject: {
      type: Object,
      required: false,
    },
    internalPincodes: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [GetAllPolls, GetScratchPadText],
  data() {
    return {
      itemsPerPage: 100,
      page: 1,
      viewMode: "list",
      searchQuery: "",
      selectedSort: "newest",
      filterStatus: "LIVE",

      // Filter options mapped for the chip group
      statusFilters: [
        { label: "Live", value: "LIVE" },
        { label: "Upcoming", value: "UPCOMING" },
        { label: "Completed", value: "COMPLETED" },
        { label: "Aborted", value: "ABORTED" },
        { label: "Private", value: "PRIVATE" },
      ],

      sortOptions: [
        { title: "Newest First", value: "newest" },
        { title: "Oldest First", value: "oldest" },
        { title: "Most Votes", value: "votes" },
        { title: "Least Votes", value: "least-votes" },
      ],
      // Dialog properties
      loading: false,
      isDelete: false,
      pollDialog: false,
      showResultCard: false,
      activateDeactivatePollDialog: false,
      selectedPoll: {},
      headers: [
        { title: "Poll Title", key: "title", width: "40%" },
        { title: "Votes", key: "vote_counts", width: "5%" },
        { title: "Created By", key: "creator_email_id", width: "15%" },
        { title: "Scope", key: "target_value", width: "15%" },
        { title: "Expires in", key: "created_at", width: "15%" },
        { title: "Actions", key: "actions", sortable: false, width: "5%" },
      ],
      GetAllPollsList: [],
    };
  },
  async mounted() {
    await this.GetAllPollsMethod(this.filterStatus);
    await this.GetScratchPadTextMethod();
  },
  computed: {
    filteredPolls() {
      let results = this.GetAllPollsList.filter((poll) => {
        const matchesSearch = poll.title
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesStatus =
          this.selectedStatus === "ALL" ||
          poll.poll_status === this.selectedStatus;
        return matchesSearch && matchesStatus;
      });

      // Sort
      if (this.selectedSort === "newest") {
        results.sort((a, b) => b.id - a.id);
      } else if (this.selectedSort === "oldest") {
        results.sort((a, b) => a.id - b.id);
      } else if (this.selectedSort === "votes") {
        results.sort((a, b) => b.votes - a.votes);
      } else if (this.selectedSort === "least-votes") {
        results.sort((a, b) => a.votes - b.votes);
      }

      return results;
    },
    pageCount() {
      return Math.ceil(this.GetAllPollsList.length / this.itemsPerPage);
    },
  },
  watch: {
    // This watcher already exists and will perfectly handle the chip clicks
    async filterStatus(newStatus) {
      await this.GetAllPollsMethod(newStatus);
    },
  },
  methods: {
    getTimelineProgress(item) {
      if (!item.created_at || !item.end_time) return 0;

      const now = Date.now();
      const start = item.created_at;
      const end = item.end_time;

      if (now >= end) return 100; // Poll ended
      if (now <= start) return 0; // Poll hasn't started

      const totalDuration = end - start;
      const elapsed = now - start;

      return Math.round((elapsed / totalDuration) * 100);
    },

    getTimeLeftText(item) {
      if (!item.end_time) return "N/A";

      const now = Date.now();
      const end = item.end_time;

      if (now >= end) return "Completed";

      const diffMs = end - now;
      const diffMins = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffDays > 0) return `${diffDays} day${diffDays > 1 ? "s" : ""} left`;
      if (diffHours > 0)
        return `${diffHours} hr${diffHours > 1 ? "s" : ""} left`;
      return `${diffMins} min${diffMins > 1 ? "s" : ""} left`;
    },

    getTimeColor(item) {
      const progress = this.getTimelineProgress(item);
      if (progress >= 100) return "primary"; // Ended
      if (progress >= 85) return "error"; // Almost over (Red)
      if (progress >= 50) return "warning"; // Halfway (Yellow)
      return "success"; // Plenty of time (Green)
    },

    getTimeColorText(item) {
      const progress = this.getTimelineProgress(item);
      if (progress >= 100) return "text-grey-darken-1";
      if (progress >= 85) return "text-error";
      if (progress >= 50) return "text-warning text-darken-2";
      return "text-success text-darken-1";
    },
    viewResults(event, data) {
      this.selectedPoll = data.item;
      this.showResultCard = true;
    },
    openCreateDialog() {
      this.selectedPoll = {};
      this.selectedPoll.type = "create";
      this.pollDialog = true;
    },
    editPoll(poll) {
      this.selectedPoll = poll;
      this.selectedPoll.type = "edit";
      this.pollDialog = true;
    },
    deletePoll(poll) {
      this.selectedPoll = poll;
      this.activateDeactivatePollDialog = true;
    },
    async activateDeactivatePollDialogEmit(Toggle) {
      this.isDelete = false;
      this.activateDeactivatePollDialog = false;
      if (Toggle == 2) {
        await this.GetAllPollsMethod();
      }
    },
    rePollMethod(item) {
      if (item) {
        this.selectedPoll = item;
      }
      this.selectedPoll.type = "repoll";
      this.showResultCard = false;
      setTimeout(() => {
        this.pollDialog = true;
      }, 100);
    },
    nextPollMethod(ind) {
      if (ind != -1 && ind < this.GetAllPollsList.length) {
        this.selectedPoll = this.GetAllPollsList[ind + 1];
      }
    },
    previousPollMethod(ind) {
      if (ind != -1 && ind > 0) {
        this.selectedPoll = this.GetAllPollsList[ind - 1];
      }
    },
    async pollDialogEmitt(Toggle) {
      this.pollDialog = false;
      if (Toggle == 2) {
        await this.GetAllPollsMethod(this.filterStatus);
      }
    },
  },
};
</script>

<style scoped>
.polls-container {
  background-color: #f5f7fa;
  border-radius: 12px;
  padding: 15px !important;
}

.text-2c3e50 {
  color: #2c3e50;
}

.text-sm {
  font-size: 0.9rem;
}

.w-100 {
  width: 100%;
}

.polls-container {
  background-color: transparent;
}

.text-2c3e50 {
  color: #2c3e50;
}

.text-semibold {
  font-weight: 600;
}

.text-muted {
  color: #888888;
}

.btn-primary-gradient {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}
</style>
